



































































import { Component, Vue, VModel } from 'vue-property-decorator';
import { IServiceBanPolicy, ISelectValue, IServiceBanPolicyCreateUpdate } from '@/interfaces';
import {
  dispatchGetServices,
  dispatchUpdateServiceBanPolicy,
  dispatchCreateServiceBanPolicy,
  dispatchGetServiceBanPolicies,
  readServices,
  readServiceBanPolicies,
} from '@/store/admin/accessors';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
  },
})
export default class BanPolicyForm extends Vue {
  public valid = false;
  public serviceId: number | null = null;
  public banMultiplier: number = 1;
  public maxBans: number = 0;
  public permanentBanDuration: number | null = null;
  public repeatedBan: boolean = false;
  public moUnban: boolean = false;
  public mtUnban: boolean = false;

  public id: number | null = null;

  public servicesSelect: ISelectValue[] = [];

  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  @VModel({ type: Object })
  public banPolicy!: IServiceBanPolicy;

  public get title() {
    if (this.id) {
      return this.$vuetify.lang.t('$vuetify.updateBanPolicy');
    } else {
      return this.$vuetify.lang.t('$vuetify.createBanPolicy');
    }
  }

  public async mounted() {
    if (this.banPolicy) {
      this.id = this.banPolicy.id;
    }
    await dispatchGetServices(this.$store);
    await dispatchGetServiceBanPolicies(this.$store);
    const existingPoliciesServices = readServiceBanPolicies(this.$store).map((item) => item.service_id);
    for (const item of readServices(this.$store)) {
      if (!!this.id || !existingPoliciesServices.includes(item.id)) {
        this.servicesSelect.push({ text: item.name, value: item.id });
      }
    }
    this.reset();
  }

  public reset() {
    if (this.banPolicy) {
      this.serviceId = this.banPolicy.service_id;
      this.banMultiplier = this.banPolicy.ban_multiplier;
      this.maxBans = this.banPolicy.max_bans;
      this.permanentBanDuration = this.banPolicy.permanent_ban_duration;
      this.repeatedBan = this.banPolicy.repeated_ban;
      this.moUnban = this.banPolicy.mo_unban;
      this.mtUnban = this.banPolicy.mt_unban;
    } else {
      this.serviceId = null;
      this.banMultiplier = 1;
      this.maxBans = 0;
      this.permanentBanDuration = null;
      this.repeatedBan = false;
      this.moUnban = false;
      this.mtUnban = false;
    }

    this.$refs.observer.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const item: IServiceBanPolicyCreateUpdate = {
        service_id: this.serviceId!,
        ban_multiplier: this.banMultiplier,
        max_bans: this.maxBans,
        permanent_ban_duration: this.permanentBanDuration!,
        repeated_ban: this.repeatedBan,
        mo_unban: this.moUnban,
        mt_unban: this.mtUnban,
      };
      let result: boolean;
      if (this.id) {
        result = await dispatchUpdateServiceBanPolicy(this.$store, { id: this.id, serviceBanPolicy: item });
      } else {
        result = await dispatchCreateServiceBanPolicy(this.$store, item);
      }
      if (result) {
        this.$router.push('/main/admin/ban_policies');
      }
    }
  }
}
